export enum FCRAWorkerAddressEnum {
  Active = 'active',
  Address1 = 'address1',
  Address2 = 'address2',
  City = 'city',
  County = 'county',
  FirstSeen = 'first_seen',
  Id = 'id',
  IsCurrentAddress = 'is_current_address',
  LastSeen = 'last_seen',
  Latitude = 'latitude',
  Longitude = 'longitude',
  State = 'state',
  Zip4 = 'zip4',
  Zip = 'zip',
}

export enum OneOffCheckActionEnum {
  Attention = 'attention',
  Clear = 'clear',
  Consider = 'consider',
  Fulfilled = 'fulfilled',
  ToAttention = 'to_attention',
  ToFulfilled = 'to_fulfilled',
  ToInitiated = 'to_initiated',
  ToProcessing = 'to_processing',
  ToWithdrawn = 'to_withdrawn',
  Unsolved = 'unsolved',
  Withdrawn = 'withdrawn',
}

export enum FCRAWorkerCheckRecordCrimTypeEnum {
  County = 'COUNTY',
  National = 'NATIONAL',
  SexOffenderRegistry = 'SEX_OFFENDER_REGISTRY',
}

export enum FCRAWorkerCheckRecordMatchTypeEnum {
  DayMonthMatch = 'DayMonthMatch',
  ExactMatch = 'ExactMatch',
  Match = 'Match',
  MonthYearMatch = 'MonthYearMatch',
  NA = 'NA',
  NoMatch = 'NoMatch',
  PartialMatch = 'PartialMatch',
  YearMatch = 'YearMatch',
}

export enum FCRAWorkerCheckRecordOverrideLogicEnum {
  Hide = 'HIDE',
  NA = 'NA',
  Show = 'SHOW',
}

export enum FCRAWorkerCheckRecordTypeEnum {
  County = 'COUNTY',
  Federal = 'FEDERAL',
  MvrAccident = 'MVR_ACCIDENT',
  MvrAction = 'MVR_ACTION',
  MvrViolation = 'MVR_VIOLATION',
  National = 'NATIONAL',
  SexOffender = 'SEX_OFFENDER',
  Watchlist = 'WATCHLIST',
}

export enum ProfileStatusEnum {
  Approved = 'approved',
  Consent = 'consent',
  Emailed = 'emailed',
  Initiated = 'initiated',
  Pending = 'pending',
  PendingDispute = 'pending__dispute',
  PendingFirstNotice = 'pending__first_notice',
  PendingResolved = 'pending__resolved',
  PendingSecondNotice = 'pending__second_notice',
  Processing = 'processing',
  Rejected = 'rejected',
  Review = 'review',
  ReviewCm = 'review__cm',
  ReviewIdentity = 'review__identity',
  ReviewMvr = 'review__mvr',
  ReviewQa = 'review__qa',
  ReviewSo = 'review__so',
  Withdrawn = 'withdrawn',
}

export enum ProfileStatusLabel {
  Approved = 'approved',
  Consent = 'consent',
  Consider = 'consider',
  Emailed = 'emailed',
  FirstNotice = '1st notice',
  Initiated = 'initiated',
  PendingDispute = 'pending_dispute',
  PendingResolved = 'pending_resolved',
  Processing = 'processing',
  Rejected = 'rejected',
  ReviewCm = 'review_cm',
  ReviewIdentity = 'review_identity',
  ReviewMvr = 'review_mvr',
  ReviewQa = 'review_qa',
  ReviewSo = 'review_so',
  Reviewing = 'reviewing',
  SecondNotice = '2nd notice',
  Withdrawn = 'withdrawn',
}

export enum TurnActionsEnum {
  Reviewed = 'reviewed',
  SetCurrentAddress = 'set_current_address',
  UpdateConnectOrderReport = 'update_connect_order_report',
}

export enum TurnReferencesEnum {
  AdminPartners = 'admin/partners',
  AdminMVRProviders = 'turn_admin/mvr_providers',
  AdminServiceProviders = 'turn_admin/service_providers',
  AdminStates = 'turn_admin/states',
  Adverse = 'adverse',
  Candidates = 'candidates',
  CmCriminal = 'cm_criminal',
  CriminalRecords = 'criminal_records',
  NationalRecord = 'national-record',
}

export enum TurnResourcesEnum {
  CandidateConsentEmail = 'candidate_consent_email',
  CmCriminalRecords = 'cm_criminal_records',
  CmFederalRecords = 'cm_federal_records',
  CmMvrRecords = 'cm_mvr_records',
  CompassOrderReports = 'compass_order_reports',
  Counties = 'counties',
  FcraWorkers = 'fcra_workers',
  FcraWorkersAdverse = 'fcra_workers_adverse',
  FcraWorkersCountyCriminalRecords = 'fcra_workers_county_criminal_records',
  FederalRecords = 'federal_records',
  MonitoringCriminal = 'monitoring/criminal',
  MvrRecords = 'mvr_records',
  NationalRecord = 'national-record',
  NationalRecords = 'national_records',
  OneOffChecks = 'one_off_checks',
  States = 'states',
  TurnAdminServiceProviders = 'turn_admin/service_providers',
  CandidateNotes = 'candidate_notes',
  TurnAdminStates = 'turn_admin/states',
}

export enum TurnTargetsEnum {
  Actions = 'actions',
  Addresses = 'addresses',
  BackgroundChecks = 'background_checks',
  ControlNumbers = 'control_numbers',
  Counties = 'counties',
  CountyCheck = 'county_check',
  DisableConsentLink = 'disable_consent_link',
  Dispute = 'dispute',
  DoMvr = 'do_mvr',
  EditDispute = 'edit_dispute',
  EditNote = 'edit_note',
  EditStatus = 'edit_status',
  Events = 'events',
  GetAlerts = 'get_alerts',
  Match = 'match',
  MoveWorkerForward = 'move_worker_forward',
  NoMatch = 'no_match',
  Note = 'note',
  OneOffChecks = 'one_off_checks',
  RerunAddresses = 'rerun_addresses',
  ResumeChecks = 'resume_checks',
  SendAdverse = 'send_adverse',
  SendPreadverse = 'send_preadverse',
  SetOverrideBulk = 'set_override_bulk',
  SetPending = 'set_pending',
  StopRecheck = 'stop_recheck',
  UpdateActiveAddress = 'update_active_address',
  UpdateWorkerCriminalRecord = 'update_worker_criminal_record',
  UpdateWorkerFederalRecord = 'update_worker_federal_record',
  UpdateWorkerMvrAccident = 'update_worker_mvr_accident',
  UpdateWorkerMvrAction = 'update_worker_mvr_action',
  UpdateWorkerMvrLicense = 'update_worker_mvr_license',
  UpdateWorkerMvrViolation = 'update_worker_mvr_violation',
  UpdateWorkerNationalRecord = 'update_worker_national_record',
  UpdateWorkerSexOffenderRecord = 'update_worker_sex_offender_record',
  UpdateWorkerWatchlistRecord = 'update_worker_watchlist_record',
  WorkerCountyCriminalRecords = 'worker_county_criminal_records',
  WorkerFederalRecords = 'worker_federal_records',
  WorkerMvrAccidents = 'worker_mvr_accidents',
  WorkerMvrActions = 'worker_mvr_actions',
  WorkerMvrLicense = 'worker_mvr_license',
  WorkerMvrViolations = 'worker_mvr_violations',
  WorkerNationalRecords = 'worker_national_records',
  WorkerSexOffenderRecords = 'worker_sex_offender_records',
  CandidateNoteHistory = 'candidate_note_history',
  CandidateNotes = 'candidate_notes',
  WorkerWatchlistRecords = 'worker_watchlist_records',
}
